import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatStarRating = createCustomElementWrapper('kat-star-rating', 'KatStarRating', {
    'errorLabel': 'error-label',
}, {
    'onChange': 'change',
});
